import { defineStore } from "pinia";
import apiClient from "@/plugins/axios";

export const useNewsDetailStore = defineStore("newsDetail", {
  state: () => ({
    news: null,
    loading: false,
    error: "",
  }),

  actions: {
    /**
     * Obtener detalle de una noticia
     */
    async fetchNewsDetail(id) {
      this.loading = true;
      this.error = "";
      this.news = null;

      try {
        const response = await apiClient.get(`/public/news/${id}`);
        const data = response.data;

        this.news = {
          id: data.id,
          title: data.title,
          date: data.date,
          image_path: data.image_path,
          summary: data.summary,
          detail: data.detail,
        };
      } catch (error) {
        if (error.code === "ERR_NETWORK") {
          this.error =
            "No se pudo conectar al servidor. Por favor, intenta nuevamente más tarde.";
        } else if (error.response?.status === 404) {
          this.error = "La noticia solicitada no fue encontrada.";
        } else {
          this.error =
            error.response?.data?.message ||
            "Error al cargar la noticia. Intente de nuevo más tarde.";
        }
      } finally {
        this.loading = false;
      }
    },
  },
});
